// ABOUTME: An option's media as it was made, for an option no post plan places on a
// platform yet (a video job's cut offered without one): each file at its own aspect,
// with the browser's own controls. Planned options are drawn by PlatformMockup instead.
import { previewAssetUrl, type PreviewMediaItem } from '@/api/previews'

function aspect(item: PreviewMediaItem): string {
  return item.width && item.height ? `${item.width} / ${item.height}` : '9 / 16'
}

export function OptionMedia({ media }: { media: PreviewMediaItem[] }) {
  return (
    <div className="flex w-full max-w-[300px] flex-col gap-2" data-testid="option-media">
      {media.map((item, index) => (
        <div
          key={`${index}-${item.url}`}
          className="bg-muted w-full overflow-hidden rounded-xl"
          style={{ aspectRatio: aspect(item) }}
        >
          {item.kind === 'video' ? (
            <video
              className="h-full w-full object-contain"
              src={previewAssetUrl(item.url)}
              poster={item.poster_url ? previewAssetUrl(item.poster_url) : undefined}
              // With no poster, the first frame stands in for one.
              preload={item.poster_url ? 'none' : 'metadata'}
              playsInline
              controls
            />
          ) : (
            <img
              className="h-full w-full object-contain"
              src={previewAssetUrl(item.url)}
              alt=""
              draggable={false}
            />
          )}
        </div>
      ))}
    </div>
  )
}
